<template>
<section class="invoice-add-wrapper">
  <b-row class="invoice-add">

    <!-- Col: Left (Invoice Container) -->
    <b-col cols="12" xl="4" md="4">
      <b-card>
        <b-card style="background:#eee;">
          {{student.code}} - {{student.zh_name}} {{student.en_name}}<br>
          {{student.grade}}
        </b-card>
        <b-tabs>
          <b-tab title="常班">
            <b-row>
              <b-col md="12">
                <b-form-group label="上課地點" label-for="上課地點">
                  <v-select :clearable="false" v-model="form.center" label="display_name" :options="centers" :reduce="center => center.id" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Grade" label-for="Grade">
                  <v-select v-model="form.grade" label="label" :options="grades" :reduce="grade => grade.code" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="開始上課日期" label-for="開始上課日期">
                  <flat-pickr v-model="form.start_at" class="form-control" :config="{ dateFormat: 'Y-m-d', altInput: true,altFormat: 'j F, Y'}" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="老師" label-for="老師">
                  <v-select v-model="form.user_id" :options="staffOptions" :reduce="user => user.value" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="優惠" label-for="優惠">
                  <v-select v-model="form.package" label="name" :options="available_package" :reduce="selected_package => selected_package.id" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <div class="class-time-panel mt-1">
                    <div class="class-time-label">上課時間</div>
                    <b-row class="align-items-center justify-content-center no-gutters class-time-row">
                    <b-col cols="5">
                        <v-select v-model="form.class_hour" :clearable="false" label="label" :options="hourOptions" :reduce="hour => hour.value" class="class-time-select" />
                    </b-col>
                    <b-col cols="2" class="text-center class-time-separator">
                        :
                    </b-col>
                    <b-col cols="5">
                        <v-select v-model="form.class_minute" :clearable="false" label="label" :options="minuteOptions" :reduce="minute => minute.value" class="class-time-select" />
                    </b-col>
                    </b-row>
                    <div class="class-time-preview text-center">
                        {{ form.class_hour || '--' }} : {{ form.class_minute || '--' }}
                    </div>
                </div>
              </b-col>
               
            </b-row>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="my-75" block="block" @click="add_item('course')">
              確定增加
            </b-button>
          </b-tab>
          <b-tab title="產品">
            <b-row>
              <!--<b-col md="12">
                <b-form-group label="產品類別" label-for="產品類別">
                  <v-select v-model="product.category" label="label" :options="category" :reduce="category => category.id" />
                </b-form-group>
              </b-col>-->
              <b-col md="12">
                <b-form-group label="產品" label-for="產品">
                  <v-select v-model="product.detail" label="label" :options="products" />
                </b-form-group>
                <b-form-group label="產品選項" label-for="產品選項" v-if="product_sku_available === true">
                  <v-select v-model="product.sku" label="label" :options="product_sku" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <label for="sb-large">數量</label>
                <b-form-spinbutton class="mb-1" min="1" v-model="product.quantity" />
              </b-col>
            </b-row>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="my-75" block="block" @click="add_item('product')">
              確定增加
            </b-button>
          </b-tab>



          <b-tab title="短期課程">
            <b-row>
              <b-col md="12">
                <b-form-group label="短期課程" label-for="短期課程">
                  <v-select v-model="form_short_course.course" label="label" :options="short_courses" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="上課地點" label-for="上課地點">
                  <v-select v-model="form_short_course.center" label="display_name" :options="centers" :reduce="center => center.id" />
                </b-form-group>
              </b-col>
              <hr />
              <b-col md="12">
                <b-form-group label="上課日期" label-for="上課日期">
                  <flat-pickr v-model="form_short_course.selected_date" class="form-control" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
             <b-col md="12">
                <b-form-group label="老師" label-for="老師">
                  <v-select v-model="form_short_course.user_id" :options="staffOptions" :reduce="user => user.value" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
            <b-col md="12">
                <div class="class-time-panel mt-1">
                    <div class="class-time-label">上課時間</div>
                    <b-row class="align-items-center justify-content-center no-gutters class-time-row">
                    <b-col cols="5">
                        <v-select v-model="form_short_course.class_hour" :clearable="false" label="label" :options="hourOptions" :reduce="hour => hour.value" class="class-time-select" />
                    </b-col>
                    <b-col cols="2" class="text-center class-time-separator">
                        :
                    </b-col>
                    <b-col cols="5">
                        <v-select v-model="form_short_course.class_minute" :clearable="false" label="label" :options="minuteOptions" :reduce="minute => minute.value" class="class-time-select" />
                    </b-col>
                    </b-row>
                    <div class="class-time-preview text-center">
                        {{ form_short_course.class_hour || '--' }} : {{ form_short_course.class_minute || '--' }}
                    </div>
                </div>
                   <b-button size="sm" block variant="outline-primary" class="mt-1" @click="confirm_short_course_date()">確定日期 ( {{ available_short_course_quantity }} )</b-button>

              </b-col>
              </b-row>
            <hr />
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="my-75" block="block" @click="add_item('short_course')">
              確定增加 
            </b-button>

            <b-list-group flush="flush">
              <b-list-group-item v-for="(item, index) in form_short_course.available_class" :key="index" @click="short_course_select_class(item)" class="d-flex justify-content-between align-items-center" :style="'cursor:pointer;background:#'+item.color">
                <span style="font-size:12px;">{{item.start}}-{{item.end}} | {{item.name}}  {{item.display_name}}</span>
                <b-badge variant="primary" pill="pill" class="badge-round">
                  {{item.existing_booking}}
                </b-badge>
              </b-list-group-item>
            </b-list-group>
          </b-tab>


          <b-tab title="試堂">
            <b-row>
              <b-col md="12">
                <b-form-group label="上課地點" label-for="上課地點">
                  <v-select v-model="form_trial.center" label="display_name" :options="centers" :reduce="center => center.id" />
                </b-form-group>
              </b-col>
              <hr />
              <b-col md="12">
                <b-form-group label="上課日期" label-for="上課日期">
                  <flat-pickr v-model="form_trial.selected_date" class="form-control" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="課程等級" label-for="課程等級">
                  <v-select v-model="form_trial.selected_grade_id" label="label" :options="grades" :reduce="grade => grade.grade_id" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="老師" label-for="老師">
                  <v-select v-model="form_trial.selected_user_id" :options="staffOptions" :reduce="user => user.value" />
                </b-form-group>
              </b-col>
              <b-col md="12">
              <div class="class-time-panel mt-1">
                    <div class="class-time-label">上課時間</div>
                    <b-row class="align-items-center justify-content-center no-gutters class-time-row">
                    <b-col cols="5">
                        <v-select v-model="form_trial.class_hour" :clearable="false" label="label" :options="hourOptions" :reduce="hour => hour.value" class="class-time-select" />
                    </b-col>
                    <b-col cols="2" class="text-center class-time-separator">
                        :
                    </b-col>
                    <b-col cols="5">
                        <v-select v-model="form_trial.class_minute" :clearable="false" label="label" :options="minuteOptions" :reduce="minute => minute.value" class="class-time-select" />
                    </b-col>
                    </b-row>
                    <div class="class-time-preview text-center">
                        {{ form_trial.class_hour || '--' }} : {{ form_trial.class_minute || '--' }}
                    </div>
                </div>
              </b-col>
            </b-row>
            <hr />

            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="my-75" block="block" @click="add_item('trial')">
              確定增加
            </b-button>
            <b-list-group flush="flush">
              <b-list-group-item v-for="(item, index) in form_trial.available_class" :key="index" @click="trial_select_class(item)" class="d-flex justify-content-between align-items-center" :style="'cursor:pointer;background:#'+item.color">
                <span style="font-size:12px;">{{item.start}}-{{item.end}} | {{item.name}}  {{item.display_name}}</span>
                <b-badge variant="primary" pill="pill" class="badge-round">
                  {{item.existing_booking}}
                </b-badge>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="升級">
            <b-row>
              <b-col md="12">
                <b-form-group label="可升級課程" label-for="可升級課程">
                  <v-select v-model="form_upgrade.selected_course" :clearable="false" class="" label="label" :options="form_upgrade.available_courses" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="升級至" label-for="升級至">
                    <v-select v-model="form_upgrade.selected_upgrade" :clearable="false" label="label" :options="this.available_upgrade" />
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b @click="get_available_upgrade()">已取贈品</b>
            <b-list-group flush="flush" v-if="form_upgrade.selected_course">
              <b-list-group-item v-for="(item, index) in form_upgrade.selected_course.items" :key="index" class="d-flex justify-content-between align-items-center" >
                <span>{{item.item_name}}</span>
              </b-list-group-item>
            </b-list-group>
            <hr />
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="my-75" block="block" @click="add_item('upgrade')">
              確定增加
            </b-button>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <b-col cols="3" md="5" xl="5" class="invoice-actions mt-md-0 mt-2">
      <b-card>
        <h5>課程金額</h5>
        <div class="price" v-if="invoice_total > 0">HKD ${{invoice_total}}</div>
        <div v-if="selected_package" style="font-size:13px;color:#999;">{{selected_package.price_detail}}</div>
        <hr />
        <h5>優惠附帶產品</h5>
        <b-list-group flush="flush">

          <div v-for="(product, index) in selected_package_product" :key="index">
            <div v-if="Array.isArray(product) === true">
              <div v-for="(or_product, j) in product" :key="j">
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <span>{{or_product.selector}}
                    -
                    {{or_product.product_name}} <span v-if="parseInt(or_product.addon_amount) != 0" class="text-danger"> <b> ${{ or_product.addon_amount }}</b></span></span>
                  <!--<span v-if="or_product.sku.length > 0">
                      <v-select v-model="or_product.selected_sku" :clearable="false" class="select-size-sm" label="name" :options="or_product.sku" :reduce="sku => sku.id" />
                    </span>-->
                  <b-badge @click="selector1(or_product.set_item_id,or_product.selector)" variant="primary" pill="pill" style="cursor:pointer;" class="badge-round" :class="or_product.selector">
                    {{or_product.selector}}
                  </b-badge>
                </b-list-group-item>
              </div>
            </div>
            <div v-if="Array.isArray(product) === false">
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <span>
                  <b-form-checkbox v-model="product.is_collected" value="Y">
                    <span v-if="product.product_type == 'SHORT_COURSE'">{{product.product_name}}</span>
                    <span v-if="product.product_type == 'PRODUCT' || product.product_type == 'E_COUPON'">{{product.product_name}}</span>
                    <span v-if="product.product_type == 'FORM'">{{ product.form_name }}</span>
                    <span v-if="parseInt(product.addon_amount) != 0" class="text-danger"> <b> ${{ product.addon_amount }}</b></span>
                  </b-form-checkbox>
                </span>
                <span v-if="product.sku_length > 0">
                  <v-select v-model="product.selected_sku" :clearable="false" class="select-size-sm" label="name" :options="product.sku" :reduce="sku => sku.id" />
                </span>
              </b-list-group-item>
            </div>
          </div>
        </b-list-group>
        <hr />
        <h5 class="mt-1">上課日期</h5>

        <b-row>
          <b-col cols="6" class="mt-1" v-for="(date, index) in selected_class_date" :key="index">
            <b-badge :variant="classDateBadgeVariant(date.class_date)" class="badge-round" style="cursor:pointer" @click="delete_selected_class_date(index,date.type)"> {{index + 1}}</b-badge>
            <b v-if="date.type"> {{ formatClassDate(date.class_date) }} {{date.start}}-{{date.end}}</b>
            <b v-else> {{ formatClassDate(date.class_date) }}</b>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <!-- Right Col: Card -->
    <b-col cols="12" md="3" xl="3" class="invoice-actions mt-md-0 mt-2">

      <!-- Action Buttons -->
      <b-card>
        <b-list-group flush="flush">
          <b-list-group-item v-for="(item, index) in cart" :key="index" class="d-flex justify-content-between align-items-center">
            <b v-if="item.type=='course'">{{item.start_at}} ({{item.grade}})</b>
            <b v-if="item.type=='upgrade'">升級課程</b>
            <b v-if="item.type=='short_course'">{{item.course.name}} </b>
            <b v-if="item.type=='trial'">試堂</b>
            <b v-if="item.type=='addon'">加購選項</b>
            <b v-if="item.type=='product' && item.sku == null ">{{item.detail.label}} x {{item.quantity}} </b>
            <b v-if="item.type=='product' && item.sku != null ">{{item.detail.product_name}} ${{item.sku.price}} <br>{{item.sku.name}} x {{item.quantity}} </b>
            <b-badge variant="primary" pill="pill" class="badge-round">$
              <span v-if="item.type=='course'">{{item.price}}</span>
              <span v-if="item.type=='addon'">{{item.price}}</span>
              <span v-if="item.type=='short_course'">{{item.price}}</span>
              <span v-if="item.type=='upgrade'">{{item.price}}</span>
              <span v-if="item.type=='trial'">{{item.price.toFixed(2)}}</span>
              <span v-if="item.type=='product' && item.sku != null">{{ (item.sku.price * item.quantity).toFixed(2) }}</span>
              <span v-if="item.type=='product' && item.sku == null">{{ (item.detail.price * item.quantity).toFixed(2) }}</span>
            </b-badge>
          </b-list-group-item>
        </b-list-group>

        <!-- Button: Send Invoice -->
      </b-card>
      <!-- Payment Method -->
      <div class="mt-2">
        <b-card>
          <b-form-group label="付款方式" label-for="payment-method" class="mb-1">
            <v-select v-model="selected_payment.method" :options="paymentMethods" input-id="payment-method" class="payment-selector" :clearable="false" />

            <v-select v-if="selected_payment.method.value == 'DISCOUNT'" v-model="selected_payment.discount" :options="paymentDiscounts" label="name" input-id="payment-method" class="mt-1 payment-selector" :clearable="false" />
          </b-form-group>

          <b-input-group prepend="$" class="mb-1"   v-if="selected_payment.method.value != 'VOUNCHER'">
            <b-form-input  v-model="selected_payment.amount" :disabled="select_discount" type="number"  />
            <b-input-group-append>
          <b-button variant="outline-secondary" v-if="selected_payment.method.value != 'DISCOUNT'" @click="selected_payment.amount = total_amount - payment_total">
            全數
          </b-button>
        </b-input-group-append>
          </b-input-group>

          <b-input-group prepend="編號" class="mb-1"  v-if="selected_payment.method.value == 'VOUNCHER'" >
            <b-form-input  v-model="vouncher.code" />
            <b-input-group-append>
        </b-input-group-append>
          </b-input-group>


          <b-form-input v-model="selected_payment.remarks" type="text" placeholder="備註" class="mb-2" />

          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-75" block="block" @click="add_payment()" :disabled="(selected_payment.method.value != 'VOUNCHER' && selected_payment.method.value != 'DISCOUNT' && selected_payment.amount < 1) || processing === true">
            {{loading}}
          </b-button>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-warning" class="mb-75" block="block" @click="clear_payment()">
            清除付款方式
          </b-button>

          <div v-for="(payment, index) in invoiceData.payments" :key="payment.id">
            {{payment.method.value}}
            - $
            {{payment.amount}}
            <span v-if="payment.remarks != null">({{payment.remarks}})</span>
          </div>
          <hr />
          <h5>已付 : ${{payment_total.toFixed(2)}}</h5>
          <h5 class="text-danger">未付 : ${{(total_amount - payment_total.toFixed(2)).toFixed(2)}}</h5><br>
          <h5>總計 : ${{total_amount}}</h5>
        </b-card>
        <!-- ? Below values are not adding invoiceData to keep invoiceData more generic and less confusing -->
        <b-card>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-75" block="block" @click="submit_invoice()" :disabled="cart.length < 1 || processing === true" >
            <span v-if="this.processing == false">送出</span><span v-else>請稍候...</span>
          </b-button>

          <!-- Button: DOwnload -->
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" class="mb-75" block="block" @click="back()">
            返回
          </b-button>
        </b-card>

      </div>
    </b-col>
  </b-row>
</section>
</template>

<script>
import Logo from '@core/layouts/components/Logo.vue'
import {
  ref,
  onUnmounted
} from '@vue/composition-api'
import {
  heightTransition
} from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import {
  BTabs,
  BTab,
  BFormSpinbutton,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BBadge,
  BListGroup,
  BListGroupItem,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
} from 'bootstrap-vue'
import router from '@/router'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ToastificationContent,
    router,
    BFormSpinbutton,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BTabs,
    BTab,
    BCardText,
    BForm,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    BBadge,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,

  },
  mixins: [heightTransition],
  data() {
    return {
       hourOptions: [
                {
                    label: '09',
                    value: '09'
                },
                {
                    label: '10',
                    value: '10'
                },
                {
                    label: '11',
                    value: '11'
                },
                {
                    label: '12',
                    value: '12'
                },
                {
                    label: '13',
                    value: '13'
                },
                {
                    label: '14',
                    value: '14'
                },
                {
                    label: '15',
                    value: '15'
                },
                {
                    label: '16',
                    value: '16'
                },
                {
                    label: '17',
                    value: '17'
                },
                {
                    label: '18',
                    value: '18'
                },
                {
                    label: '19',
                    value: '19'
                },
                {
                    label: '20',
                    value: '20'
                }

            ],
            minuteOptions: [{
                    label: '00',
                    value: '00'
                },
                {
                    label: '15',
                    value: '15'
                },
                {
                    label: '30',
                    value: '30'
                },
                {
                    label: '45',
                    value: '45'
                }
            ],
      staffOptions: [],
      cart: [],
      total_amount: 0,
      form: {
        center: null,
        grade: null,
        class_id: null,
        start_at: null,
        start: null,
        user_id: null,
        package: null,
        price: 0,
        type: null
      },
      form_upgrade : {

      },
      form_short_course: {
        course:{
          quantity: 0
        },
        center: null,
        selected_date: null,
        available_class: [],
        selected_date:[]

      },
      form_trial: {
        center: null,
        selected_date: null,
        class_hour: null,
        class_minute: null,
        selected_grade_id: null,
        selected_user_id: null,
        available_class: [],
        selected_classes:[]
      },
      processing: false,
      available_class: [],
      upgrade_detail:null,
      vouncher: {
        code: null,
      },
      products: [],
      product: {
        quantity: 1,
        detail: null,
        sku: null
      },
      add_process : {
        action : false,
        addon_amount : 0
      },
      available_upgrade:[],
      product_sku: [],
      select_discount: false,
      product_sku_available: false,
      invoice_total: 0,
      available_package: [],
      selected_package_product: [],
      selected_class_date: [],
      short_courses: [],
      student:null,
      package_product: [],
      centers: [],
      grades: [],
      paymentMethods: [],
      paymentDiscounts:[],
      selected_payment: {
        method: {
          label: null,
          value: null
        },
        amount: null
      },
      invoice: {
        subtotal: 0,
        discount: 0,
        total: 0
      },
      invoiceData: {
        items: [],
        payments: [],
        total_amount: 0,
      },
      card: {
        number: null,
        expire: null,
        cvc: null,
        amount: 0,
        member_id: null
      },
      paymentOptions: [],
      itemsOptions: [],
      invoiceData: {
        items: [],
        payments: [],
        total_amount: 0,
      }
    }
  },
  watch: {
    cart: {
      handler(newValue, oldValue) {
        let total = 0
        this.cart.forEach((item, i) => {
          switch (item.type) {
            case "short_course":
            case "course":
            case "upgrade":
            case "addon":
            case "trial":
              total += parseInt(item.price)
              break;
            case "product":
              if (item.sku == null) {
                total += item.detail.price * item.quantity
              } else {
                total += item.sku.price * item.quantity
              }
              break;
          }
        });
        this.total_amount = total.toFixed(2)
      }
    },
    "form_upgrade.selected_course": {
      handler(newValue, oldValue) {
        this.get_available_upgrade()
      },
    },
    "form_upgrade.selected_upgrade": {
      handler(newValue,oldValue) {
          this.get_upgrade_detail()
      }
    },
    "form.grade": {
      handler(newValue, oldValue) {
        if (this.form.grade != null && this.form.center != null && this.form.start_at != null) {
          this.form.class_id = null
          this.get_available_class(this.form)
        }
      },
    },
    "form.center": {
      handler(newValue, oldValue) {
        if (this.form.grade != null && this.form.center != null && this.form.start_at != null) {
          this.form.class_id = null
          this.get_available_class(this.form)
        }
      },
    },
    "form.start_at": {
      handler(newValue, oldValue) {
        if (this.form.grade != null && this.form.center != null && this.form.start_at != null) {
          this.form.class_id = null
          this.get_available_class(this.form)
        }
      },
    },
    "form.package": {
      handler(newValue, oldValue) {
        this.selected_class_date = []
        this.get_package_detail(newValue)
      },
    },
    "product.detail": {
      handler(newValue, oldValue) {
        this.get_sku()
      }
    },
    "form_short_course.course": {
      handler(newValue, oldValue) {
        this.invoice_total = parseInt(newValue.price).toFixed(2)
        this.selected_package_product = newValue.product
        this.selected_class_date = res.data.classes
      }
    },
  "form_trial.center": {
    handler(newValue, oldValue) {
      console.log("trial changed")
      if (this.form_trial.center != null && this.form_trial.selected_date != null) {
        this.get_class('trial', this.form_trial.center , this.form_trial.selected_date)
      }
    }
  },
  "form_trial.selected_date": {
    handler(newValue, oldValue) {
      console.log("trial changed")
      if (this.form_trial.center != null && this.form_trial.selected_date != null) {
        this.get_class('trial', this.form_trial.center , this.form_trial.selected_date)
      }
    }
  },
  "selected_payment.method": {
    handler(newValue, oldValue) {
      if (newValue.value == "DISCOUNT") {
        this.select_discount = true
      } else {
        this.select_discount = false
      }
    }
  },
  "selected_payment.discount": {
    handler(newValue, oldValue) {
        switch(newValue.discount_type) {
          case "PERCENTAGE":
            this.selected_payment.amount = (this.total_amount * newValue.discount_figure / 100).toFixed(2)
            break
          case "AMOUNT":
            this.selected_payment.amount = Number(newValue.discount_figure).toFixed(2)
        }

        this.selected_payment.remarks = newValue.name
    }
  }
},
  computed: {
    available_short_course_quantity() {
      if (this.form_short_course.course) {
        return this.form_short_course.course.quantity - this.selected_class_date.length
      }
      return 0
    },
    loading() {
      if (this.processing === true) {
        return "處理中..."
      } else {
        return "新增付款方式"
      }
    },
    payment_total() {
      let total = 0
      this.invoiceData.payments.forEach(item => {
        if (item.amount && item.amount > 0) {
          total += Number(item.amount)
        }
      })
      return total
    }
  },
  created() {
    this.get_student()
    this.get_center()
    this.get_grade()
    this.get_available_package()
    this.get_product()
    this.get_short_course()
    this.get_payment()
    this.get_upgrade_course()
    this.get_staffs()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    confirm_short_course_date() {
      if (this.available_short_course_quantity <= 0) {
         this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error',
            icon: 'XIcon',
            variant: 'danger',
            text: '不能選擇多於 ' +this.form_short_course.course.quantity+ ' 堂'
          },
        })
        return
      }
      const end = moment(this.form_short_course.class_hour+":"+this.form_short_course.class_minute, 'HH:mm').add(Number(this.form_short_course.course.duration), 'minutes').format('HH:mm')
      this.selected_class_date.push(
        {
          class_date: this.form_short_course.selected_date,
          start: this.form_short_course.class_hour+":"+this.form_short_course.class_minute,
          end: end,
          type: 'short_course',
          user_id: this.form_short_course.user_id
        })
      console.log(this.selected_class_date)
    },
    formatClassDate(date) {
      return moment(date).format('DD MMM YYYY')
    },
    classDateBadgeVariant(date) {
      const variants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']
      const month = moment(date).format('YYYY-MM')
      const months = []

      this.selected_class_date.forEach(classDate => {
        const classMonth = moment(classDate.class_date).format('YYYY-MM')
        if (months.indexOf(classMonth) === -1) {
          months.push(classMonth)
        }
      })

      return variants[months.indexOf(month) % variants.length]
    },
    delete_selected_class_date(index,type) {
      if (type != 'short_course') { 
        console.log(type)
        return 
      }
      this.selected_class_date.forEach( (item, ind) => {
     if(index === ind) this.selected_class_date.splice(index,1);
   });
    },
    get_available_upgrade() {
      //this.form_upgrade.available_upgrade = []
      this.$http.post(process.env.VUE_APP_API_BASE + '/course/upgrade_course/',{exist_course:this.form_upgrade.selected_course})
        .then(res => {
          this.available_upgrade = res.data.courses
          console.log(this.available_upgrade)
        })
    },
    get_staffs() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/staffs/select/?center_id=' + this.$store.getters['center/currentCenterId'])
        .then(res => {
          this.staffOptions = res.data
        })
    },
    get_upgrade_detail() {
      this.$http.post(process.env.VUE_APP_API_BASE + '/course/upgrade_course/detail_v2/',{exist_course:this.form_upgrade.selected_course , course:this.form_upgrade.selected_upgrade})
        .then(res => {
          this.upgrade_detail = res.data
          this.invoice_total = parseInt(res.data.package.price).toFixed(2)
          console.log(this.invoice_total)
          this.selected_package = res.data.package
          this.form.type = 'CLASS'
          this.form.price = parseInt(res.data.package.price).toFixed(2)
          this.selected_package_product = res.data.package.product
          this.selected_class_date = res.data.classes

        })
    },
    get_upgrade_course(){
      this.$http.get(process.env.VUE_APP_API_BASE + '/student/'+ router.currentRoute.params.id + '/upgrade_course/')
        .then(res => {
          this.form_upgrade.available_courses = res.data
        })
    },
    trial_select_class(selected_class) {
      selected_class.type = 'trial'
      if (this.selected_class_date.length < 1) {
        this.form_trial.selected_classes.push(selected_class)
        this.selected_class_date.push(selected_class)
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error',
            icon: 'XIcon',
            variant: 'danger',
            text: '不能選擇多於 1 堂',
          },
        })
      }
    },
    short_course_select_class(selected_class) {
      selected_class.type = 'short_course'
      if (this.form_short_course.course.quantity > this.selected_class_date.length) {
        this.form_short_course.selected_classes.push(selected_class)
        this.selected_class_date.push(selected_class)
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error',
            icon: 'XIcon',
            variant: 'danger',
            text: '不能選擇多於 ' +this.form_short_course.course.quantity+ ' 堂',
          },
        })
      }
    },
    get_class(type,center_id,date) {
      this.$http.get(process.env.VUE_APP_API_BASE + '/classes/' + center_id + '/' + date + '/')
        .then(res => {
          if (type == 'short_course') { this.form_short_course.available_class = res.data.classes }
          if (type == 'trial') { this.form_trial.available_class = res.data.classes }
        })
    },
    get_payment() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/payments/?action=offer')
        .then(res => {
          this.paymentMethods = res.data.payment_methods
          this.selected_payment.method = this.paymentMethods[0]
          this.paymentDiscounts = res.data.payment_discounts
         //  this.selected_payment = this.paymentMethods
          this.paymentMethods.push({
              label: "DISCOUNT",
              value: "DISCOUNT"
          })
        })
        
      // 
    },
    get_sku() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/product/' + this.product.detail.id + '/sku/')
        .then(res => {
          this.product_sku = res.data.skus
          if (this.product_sku.length > 0) {
            this.product_sku_available = true
          } else {
            this.product_sku_available = false
          }
        })
    },
    async add_item(type,addon_price) {
      let pass = true

      switch (type) {
        case "trial":
        this.form_trial.available_class = null
        await Object.entries(this.selected_package_product).forEach(([key, value], index) => {
          if (Array.isArray(value) === true) {
            pass = false
          }
        })
        if (pass === true) {
          this.form_trial.type = 'trial'
          this.form_trial.price = 200
          this.form_trial.selected_product = this.selected_package_product
          this.selected_package_product = null
          this.selected_class_date = []
          this.cart.push(this.form_trial)
          this.invoice_total = 0
          this.form_trial = {
            center: null,
            selected_date: null,
            available_class: [],
            selected_classes:[]
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: '尚有產品未選擇',
            },
          })
        }
        break;
        case "short_course":
        this.form_short_course.available_class = null
        await Object.entries(this.selected_package_product).forEach(([key, value], index) => {
          if (Array.isArray(value) === true) {
            pass = false
          }
        })
        if (pass === true) {
          this.form_short_course.type = 'short_course'
          this.form_short_course.price = this.form_short_course.course.price
          this.form_short_course.selected_date = this.selected_class_date
          this.form_short_course.selected_product = this.selected_package_product
          this.selected_package_product = null
          this.selected_class_date = []
          this.cart.push(this.form_short_course)
          this.invoice_total = 0
          this.form_short_course = {
            course:null,
            center: null,
            selected_date: null,
            available_class: [],
            selected_classes:[]
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: '尚有產品未選擇',
            },
          })
        }
        break;
        case "upgrade":
        case "course":
          if (this.form.type === null) {
            pass = false
          }
          console.log(this.selected_package_product)
      
          await Object.entries(this.selected_package_product).forEach(([key, value], index) => {
            this.add_process = {
              action : false,
              addon_amount : 0
            }
            if (Array.isArray(value) === true) {
              pass = false
            }

            if (value.addon_amount != "0.00" && pass === true) {
              this.product.type = "addon"
              this.product.quantity = 1
              this.product.price = value.addon_amount
              this.cart.push(this.product)
              this.product = {
                quantity: 1,
                detail: null,
                sku: null
              }
            }
          })
          if ( pass === true) {
            if (type == 'upgrade') {
              this.form.exist_package = this.form_upgrade.selected_course
              this.form.package = this.form_upgrade.selected_upgrade
            }
            this.form.type = type
            this.form.selected_product = this.selected_package_product
            this.selected_package_product = null
            this.cart.push(this.form)
            this.invoice_total = 0
            this.form = {
              center: null,
              grade: null,
              class_id: null,
              start_at: null,
              start: null,
              package: null,
              price: null,
              selected_product: null
            }
            this.form.type = null
            if (this.add_process.action === true) {
              console.log(" in " + this.add_process.addon_amount)
              this.add_item("addon",this.add_process.addon_amount)
            }

          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: '尚有產品未選擇',
              },
            })
          }
          break
        case "addon":
          this.product.type = "addon"
          this.product.quantity = 1
          this.product.price = addon_price
          this.cart.push(this.product)
          this.product = {
            quantity: 1,
            detail: null,
            sku: null
          }
        break
        case "product":
          this.product.type = 'product'
          this.cart.push(this.product)
          this.product = {
            quantity: 1,
            detail: null,
            sku: null
          }
          break
      }
    },
    selector1(id, selector) {
      let selected;
      this.selected_package_product[selector].forEach((item, i) => {
        if (item.set_item_id == id) {
          selected = item
          selected.sku_length = selected.sku.length
          if ( parseInt(selected.addon_amount) != 0 ) {
            this.invoice_total = (parseInt( this.invoice_total) + parseInt(selected.addon_amount)).toFixed(2)
         //   console.log(parseInt(selected.addon_amount))
          }
        }
        this.selected_package_product[selector] = selected

      });
    },
    get_package_detail(id) {
      if (id !== null) {
        this.$http.post(process.env.VUE_APP_API_BASE + '/package/' + id + '/', this.form)
          .then(res => {
            this.invoice_total = parseInt(res.data.package.price).toFixed(2)
            this.selected_package = res.data.package
            this.form.type = 'CLASS'
            this.form.price = parseInt(res.data.package.price).toFixed(2)
            this.selected_package_product = res.data.package.product
            this.selected_class_date = res.data.classes
          })
      }
    },
    get_available_class(form) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/class/available_class/', form)
        .then(res => {
          this.available_class = res.data.classes
        })
    },
    get_student() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/student/' + router.currentRoute.params.id + '/')
        .then(res => {
          this.student = res.data
        })
    },
    get_available_package(form) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/member/' + router.currentRoute.params.id + '/available_package/')
        .then(res => {
          this.available_package = res.data.packages
        })
    },
    async submit_invoice() {

      //this.processing = true
      this.$http.post(process.env.VUE_APP_API_BASE + '/member/' + router.currentRoute.params.id + '/course/add/?center_id=' + this.$store.getters['center/currentCenterId'], {
          products: this.selected_package_product,
          form: this.cart,
          payment: this.invoiceData
        })
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.back()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })


    },

    async add_payment() {
      this.processing = true
      switch (this.selected_payment.method.value) {
         case "VOUNCHER":
        this.$http.get(process.env.VUE_APP_API_BASE + '/vouncher/'+this.student.id+'/'+this.vouncher.code+'/')
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Information',
                icon: 'StarIcon',
                variant: 'outline-primary',
                text: res.data.vouncher.name,
              }}, {
                            timeout: 100000, // 👈 6 秒（毫秒）
                            showProgress: true, // 👈 顯示 time bar（推薦）
                            closeOnClick: true,
                            pauseOnHover: true,
              }
            )
            this.selected_payment = {
              amount : res.data.vouncher.amount,
              remarks : res.data.vouncher.code,
              method : {
                label : 'VOUNCHER',
                value : 'VOUNCHER'
              }
            }
            this.add_payment_2()

          } else {
            this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: "禮券編號錯誤",
            },
          })
          this.processing = false
          return
          }
        })
          break;
        default:
          this.add_payment_2()
          break;

      }

    },
    add_payment_2() {
      this.invoiceData.payments.push(this.selected_payment)
      this.selected_payment = {
        method: {
          label: "Cash",
          value: "CASH",
          stripe_id: null,
        },
        amount: null
      }
      this.processing = false
    },
    clear_payment() {
      let pass = true
      this.invoiceData.payments.forEach(item => {
        if (item.method.value == "STRIPE") {
          pass = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: "信用卡已經付款, 不能消除",
            },
          })
          return
        }
      })
      if (pass === true) {
        this.invoiceData.payments = [];
      }
    },
    back() {
      this.$router.back()
    },
    updateItemForm(index, val) {
      //  console.log(val)
      console.clear()
      this.invoiceData.items[index].itemTitle = val
      console.log(this.invoiceData)
      //  this.invoiceData.items[index].price = val.price
      //  this.invoiceData.items[index].qty = qty
    },
    get_center() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
        .then(res => {
          this.centers = res.data.centers
          this.form.center = this.form_short_course.center = this.$store.getters['center/currentCenterId']

        })
    },
    get_grade() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/grades/')
        .then(res => {
          this.grades = res.data.grades_enable
        })
    },
    get_product() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/products/?can_buy=Y')
        .then(res => {
          this.products = res.data.products
        })
    },
    get_short_course() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/short_courses/')
        .then(res => {
          this.short_courses = res.data.short_courses
        })
    },
    get_payment_method() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/payments/')
        .then(res => {
          this.paymentMethods = res.data
        })
    },
    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)))



      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => {
          this.$refs.form.style.overflow = null
        }, 350)
      })
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.invoice-add-wrapper {
    .add-new-client-header {
        padding: $options-padding-y $options-padding-x;
        color: $success;

        &:hover {
            background-color: rgba($success, 0.12);
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
    background-color: $product-details-bg;
}

.form-item-action-col {
    width: 27px;
}

.repeater-form {
    // overflow: hidden;
    transition: 0.35s height;
}

.v-select {
    &.item-selector-title,
    &.payment-selector {
        background-color: #fff;

        .dark-layout & {
            background-color: unset;
        }
    }
}

.dark-layout {
    .form-item-section {
        background-color: $theme-dark-body-bg;

        .row .border {
            background-color: $theme-dark-card-bg;
        }

    }
}
.A {
    background: #ca9b01;
}
.B {
    background: #ca0101;
}
.C {
    background: #016eca;
}
.D {
    background: #01ca47;
}
.E {
    background: #9c01ca;
}
.F {
    background: #333;
}
.G {
    background: #a8ab59;
}
.H {
  background: #598aab;
}
.price {
    text-weight: bold;
    font-size: 15px;
}
.pointer {
  cursor: pointer;
}

.class-time-panel {
    padding: 0.75rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    background: #f8fafc;
}

.class-time-label {
    margin-bottom: 0.5rem;
    text-align: center;
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
}

.class-time-row {
    max-width: 280px;
    margin: 0 auto;
}

.class-time-separator {
    font-size: 1.25rem;
    font-weight: 700;
    color: #6b7280;
}

.class-time-preview {
    margin-top: 0.6rem;
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
    letter-spacing: 0.08em;
}
</style>
